import React, { useState } from 'react';
import { Info, Users, Shield, ClipboardCheck } from 'lucide-react';

export type TabType = 'info' | 'parteA' | 'parteB' | 'parteC';

interface ChecklistTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const tabs = [
  { id: 'info' as TabType, label: 'Info Principali', icon: Info },
  { id: 'parteA' as TabType, label: 'Parte A - Clienti', icon: Users },
  { id: 'parteB' as TabType, label: 'Parte B - AML', icon: Shield },
  { id: 'parteC' as TabType, label: 'Parte C - Altri', icon: ClipboardCheck }
];

export function ChecklistTabs({ activeTab, onTabChange }: ChecklistTabsProps) {
  return (
    <div className="border-b border-gray-200 bg-white">
      <div className="flex space-x-1 px-6">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 px-6 py-4 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
